import sanitizeHtml from 'sanitize-html';

export const sanitize = (content?: string | null | number | Boolean) => {
  return sanitizeHtml(content + '');
}